import { STANDARD_TIME } from '@/lib/constants/timeTypes'

// A day cell needs the labeled, read-only rendering whenever a bare number would be ambiguous:
// more than one Time Type entry that day, or exactly one entry that isn't Standard Time (e.g. OT
// alone) - a bare number there reads as ST by convention, which is exactly what's wrong. A single
// ST-only entry stays on the plain editable field, unchanged from today.
export function hasLabeledEntries (cell) {
  const entries = (cell && cell.entries) || []
  if (entries.length > 1) return true
  return entries.length === 1 && entries[0].timeTypeId !== STANDARD_TIME
}

const DAY_KEY = /^\d{2}\/\d{2}$/

// Time Off cells are read-only in the roster, so the server's Time Off total for the row still
// holds after an edit and can be taken out of the day cells, which mix every type.
export function rosterWorkedHours (item) {
  const allHours = Object.keys(item)
    .filter(key => DAY_KEY.test(key) && typeof (item[key] && item[key].hours) === 'number')
    .reduce((sum, key) => sum + item[key].hours, 0)
  return allHours - (item.timeOffTime || 0)
}
